/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentProcedureRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure';

export default AutomationFinAIAgentProcedureRoute;
